export default "__VITE_ASSET__DHTEgXPN__"